<template>
  <div class="flex-1 min-h-100 flex flex-col">
    <div class="w-full overflow-y-auto">
      <div class="w-full max-w-[1160px] min-w-[463px] h-100 pt-[36px] px-[32px] flex flex-col mx-auto">
        <!-- Header -->
        <div class="flex justify-between items-center">
          <span class="text-v-ui-text-monochrome title-24-medium-500">Клинически-значимые события</span>
          <v-button type="primary" label="Добавить КЗС" @click="openAddKzsPage" size="s" />
        </div>
        <!-- End Header -->
        <!-- Content -->
        <div class="mt-[24px] flex flex-col flex-1 min-h-0 pb-[50px]">
          <v-input
            v-model="searchString"
            placeholder="Введите ID или наименование события"
            @input="onSearchInput"
            class="!h-[40px]"
            contentWidth
            :leftIcon="{ name: 'search' }"
            variant="white"
          />

          <div v-if="isError" class="mt-[40px] flex-1 min-h-0 flex">
            <v-placeholder
              message="Что-то пошло не так"
              description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
              :icon="{ name: 'xl/mood-confuzed' }"
              :retry="{ label: 'Повторить запрос', handler: fetchKzsList }"
              class="!min-h-[70vh] h-full w-full !p-[24px]"
            >
              <template #footer>
                <p class="text-14-reg-400">Позвонить в техподдержку</p>
                <a
                  class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
                  href="tel:88005000299"
                  >8 800 500-02-99</a
                >
              </template>
            </v-placeholder>
          </div>


          <VPlaceholder v-else-if="totalCountInBase === 0 && !isFetching"
            message="Событий ещё нет"
            :icon="{ name: 'xl/list-check' }"
            class="!min-h-[70vh] mt-[40px] flex-1"
          />

          <VPlaceholder v-else-if="searchString && totalCount === 0 && !isFetching"
            message="События не найдены"
            :icon="{ name: 'xl/table-search' }"
            class="!min-h-[70vh] mt-[40px] flex-1"
          />

          <template v-else-if="isFetching" >
            <div class="flex flex-col rounded-[8px] bg-white border brd-accent-neutral-secondary mt-[40px] overflow-hidden">
              <div>
                <v-table-head :loading="true" />
                <v-table-line :loading="true" />
                <v-table-line :loading="true" />
                <v-table-line :loading="true" />
              </div>
            </div>
          </template>

          <template v-else>
            <div class="flex flex-col mt-[24px] pb-[55px]">
              <div class="flex gap-x-[8px] py-[16px]"> <span class="title-16-medium-500 text-heading-primary !leading-[24px]">Всего событий</span> <v-badge type="light" size="m" :content="totalCount" /></div>
              <div class="rounded-[8px] bg-white border-[1px] brd-neutral-secondary min-w-[399px] max-w-[1096px]">
                <v-table-head  :cells="tableHeadCells" class="rounded-t-[8px]"  />
                <div v-for="(kzs, index) in kzsList" :key="kzs.id">
                  <v-table-line :cells="generateTableLineCells(kzs)" :type="index % 2 === 0 ? 'gray' : 'white'" />
                </div>
                <v-table-pagination
                v-if="totalCount > limit"
                :dark="true"
                isAutoDropDown
                :currentPage="page" :limit="limit"
                :total="totalCount"
                @update:currentPage="onChangePage"
                @update:limit="onChangeLimit"
                />
              </div>
            </div>
          </template>

        </div>
        <!-- End Content -->

        <VDialog
          v-model="isDeleteKzsDialogOpen"
          title="Удаление нозологии"
          subtitle="Вы хотите удалить нозологию? Это действие невозможно отменить."
          :leftButton='{"label":"Удалить", "handler": () => this.confirmDeleteKzs()}'
          :rightButton='{"label":"Не удалять","closeOnClick":true, "closeOnClick":true}'
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  VButton,
  VInput,
  VPlaceholder,
  VTableHead,
  VTableLine,
  VBadge,
  VTablePagination,
  VDialog,
    } from '@gostelemed.front/rt-doctis.designsystem';
import kzsService from '@/services/kzs/kzs.service';
import debounce from 'lodash/debounce';
import { TOASTS } from '@/services/core/ui/toasts.const';


export default {
  name: 'Kzs',
  page: {
    title: 'CRM Doctis - Клинически-значимые события',
  },
  components: {
    VButton,
    VInput,
    VPlaceholder,
    VTableHead,
    VTableLine,
    VBadge,
    VTablePagination,
    VDialog
  },
  data() {
    return {
      isDeleteKzsDialogOpen: false,
      selectedKzsId: null,
      searchString: '',
      kzsList: null,
      isFirstFetch: true,
      page: 1,
      limit: 10,
      isFetching: true,
      isError: false,
      totalCount: 0,
      totalCountInBase: 0,
      tableHeadCells: [
      { title: "Наименование", class: 'max-w-[453px]' },
      { title: "ID", class: 'max-w-[453px]' },
      { title: "", class: 'max-w-[158px]' },
      ]
    }
  },

  async mounted() {
    await this.fetchKzsList();
  },

  created() {
    this.fetchDebouncedKzsList = debounce(this.fetchKzsList, 700);
  },

  _methods: {
    onSearchInput() {
      this.page = 1;
      this.fetchDebouncedKzsList();
    },

    async fetchKzsList() {
      this.isFetching = true;
      try {
        const data = await kzsService.getKzsList({
          search: this.searchString,
          page: this.page,
          limit: this.limit,
        });
        this.kzsList = data?.items;
        this.totalCount = data?.total;
        if (this.isFirstFetch) {
          this.totalCountInBase = data?.total;
          this.isFirstFetch = false;
        }
      } catch (error) {
        this.isError = true;
        console.error(error);
      } finally {
        this.isFetching = false;
      }
    },

    openAddKzsPage() {
      this.$router.push('/remote-monitoring/kzs/add');
    },

    generateTableLineCells(kzs) {
      return [
        {
          type: "iconWithText",
          text: kzs.name,
          class: 'max-w-[453px]'
        },
        {
          type: "iconWithText",
          text: kzs.id,
          class: 'max-w-[453px]'
        },
        {
          type: "actions",
          links: [
            {
              title: "Подробнее",
              href: `/remote-monitoring/kzs/view/${kzs.id}`,
              target: "_self",
              spaMode: true,
              click: () => this.$router.push(`/remote-monitoring/kzs/view/${kzs.id}`),
            },
          ],
          icons: [
            {
              icon: "delet",
              type: "ghost",
              class: "!icon-warning-tertiary",
              handler: () => this.openDeleteKzsDialog(kzs.id),
            },
          ],
          class: 'max-w-[158px]'
        },
      ];
    },

    openDeleteKzsDialog(id) {
      this.isDeleteKzsDialogOpen = true;
      this.selectedKzsId = id;
    },

    async confirmDeleteKzs() {
      try {
        await kzsService.deleteKzs(this.selectedKzsId);
        this.$uiService.showToast(TOASTS.KZS_TASK_DELETE_SUCCESS);
        this.isDeleteKzsDialogOpen = false;
        this.selectedKzsId = null;
        await this.fetchKzsList();
      } catch (error) {
        this.$uiService.showToast(TOASTS.KZS_TASK_DELETE_ERROR);
        console.error(error);
      }
    },

    async onChangePage(page) {
      this.page = page;
      await this.fetchKzsList();
    },

    async onChangeLimit(limit) {
      this.page = 1;
      this.limit = limit;
      await this.fetchKzsList();
    },
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
}
</script>
